(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sesh-bundles-world"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-sbw-add]');
  if (!button || button.disabled) return;
  const ids = (button.dataset.variants || '').split(',').filter(Boolean);
  if (!ids.length) return;
  const items = ids.map(function(id){ return { id: Number(id), quantity: 1 }; });
  const original = button.innerHTML;
  button.disabled = true;
  button.textContent = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('ar') ? 'جاري الإضافة…' : 'Adding…';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) throw new Error('cart');
    window.location.assign(window.Shopify.routes.root + 'cart');
  } catch (error) {
    button.disabled = false;
    button.innerHTML = original;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sesh-kinetic-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.skhCleanReady==='1') return;
    root.dataset.skhCleanReady='1';
    var slides=[].slice.call(root.querySelectorAll('[data-skh-slide]'));
    var tabs=[].slice.call(root.querySelectorAll('[data-skh-go]'));
    if(!slides.length) return;
    var current=0,startX=null,autoplay=Number(root.dataset.autoplay||0),timer=null;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function schedule(){clearTimeout(timer);if(!autoplay||reduce||document.hidden)return;timer=setTimeout(function(){show(current+1);},autoplay);}
    function show(index){current=(index+slides.length)%slides.length;slides.forEach(function(slide,i){var active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true');slide.inert=!active;});tabs.forEach(function(tab,i){var active=i===current;tab.classList.toggle('is-active',active);tab.setAttribute('aria-selected',active?'true':'false');});schedule();}
    tabs.forEach(function(tab){tab.addEventListener('click',function(){show(Number(tab.dataset.skhGo||0));});});
    root.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')startX=e.clientX;clearTimeout(timer);},{passive:true});
    root.addEventListener('pointerup',function(e){if(e.pointerType!=='touch'||startX===null)return;var delta=e.clientX-startX;startX=null;if(Math.abs(delta)>48)show(delta<0?current+1:current-1);else schedule();},{passive:true});
    document.addEventListener('visibilitychange',schedule);
    show(0);
  }
  function boot(scope){(scope||document).querySelectorAll('[data-skh-clean]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot(document);});}else{boot(document);}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sesh-routine-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-sesh-routine-add]');
  if (!button || button.disabled) return;
  const ids = (button.dataset.variants || '').split(',').filter(Boolean);
  if (!ids.length) return;
  const items = ids.map(function(id) { return { id: Number(id), quantity: 1 }; });
  const label = button.querySelector('span');
  const original = button.dataset.defaultLabel || (label ? label.textContent : button.textContent);
  button.disabled = true;
  if (label) label.textContent = button.dataset.addingLabel || original;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) throw new Error('cart');
    window.location.assign(button.dataset.cartUrl || (window.Shopify.routes.root + 'cart'));
  } catch (error) {
    button.disabled = false;
    if (label) label.textContent = original;
  }
});

  } catch(e) { console.error(e); }
})();
})();
